export default __webpack_public_path__ + "3fae7142092724a0c1b60a647bfc4edf.png";